// Volumétrie des fiches (mots, PDF, grandes parties : FICHE_DATA dans data/donnees.js) et temps de lecture.
// --- VOLUMÉTRIE DES FICHES : temps de lecture, vignette de longueur, lien direct ---
window.getFicheData = function(itemId) {
    return window.FICHE_DATA[itemId.toString()] || null;
};

window.estimateReadingMinutes = function(words) {
    if (!words) return null;
    return Math.max(1, Math.round(words / 130));
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const getFicheData = window.getFicheData;
export const estimateReadingMinutes = window.estimateReadingMinutes;
